var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 183,
    viewBox: "0 0 426 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 182.445V125.903C25.3849 125.903 46.6387 109.488 71.4347 109.488C96.2308 109.488 117.485 131.375 142.281 131.375C167.077 131.375 188.33 89.4247 213.127 89.4247C237.923 89.4247 259.176 142.319 283.972 142.319C308.768 142.319 330.022 65.7135 354.818 65.7135C379.614 65.7135 400.868 36.5305 425.664 36.5305C425.664 36.5305 425.664 36.5305 425.664 182.445",
    fill: "url(#paint0_linear_5_108)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 125.903C25.3849 125.903 46.6387 109.488 71.4347 109.488C96.2308 109.488 117.485 131.375 142.281 131.375C167.077 131.375 188.33 89.4247 213.127 89.4247C237.923 89.4247 259.176 142.319 283.972 142.319C308.768 142.319 330.022 65.7135 354.818 65.7135C379.614 65.7135 400.868 36.5305 425.664 36.5305",
    stroke: "#C93535",
    strokeWidth: 1.37065
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 182.445V162.382C25.3849 162.382 46.6387 124.079 71.4347 124.079C96.2308 124.079 117.485 60.2417 142.281 60.2417C167.077 60.2417 188.33 124.079 213.127 124.079C237.923 124.079 259.176 102.192 283.972 102.192C308.768 102.192 330.022 87.6007 354.818 87.6007C379.614 87.6007 400.868 107.664 425.664 107.664C425.664 107.664 425.664 107.664 425.664 182.445",
    fill: "url(#paint1_linear_5_108)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 162.382C25.3849 162.382 46.6387 124.079 71.4347 124.079C96.2308 124.079 117.485 60.2417 142.281 60.2417C167.077 60.2417 188.33 124.079 213.127 124.079C237.923 124.079 259.176 102.192 283.972 102.192C308.768 102.192 330.022 87.6007 354.818 87.6007C379.614 87.6007 400.868 107.664 425.664 107.664",
    stroke: "white",
    strokeWidth: 1.37065
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_108",
    x1: 0.588837,
    y1: 36.5305,
    x2: 0.588837,
    y2: 182.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C93535",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C93535",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_108",
    x1: 0.588837,
    y1: 60.2417,
    x2: 0.588837,
    y2: 182.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderContainer);
export default __webpack_public_path__ + "static/media/slider-container.1a29450bdb15601d0306c889f431a663.svg";
export { ForwardRef as ReactComponent };